/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPageD1PortfolioItemDto } from '../../models/backend-page-d-1-portfolio-item-dto';

export interface GetPortfolioEndpointDashboardsD1PortfolioGet$Params {
  /**
   * Фильтр по отрасли
   */
  industry_id?: number | null;

  /**
   * Фильтр по категории
   */
  category?: string | null;

  /**
   * Фильтр по региону
   */
  region_id?: number | null;

  /**
   * Сортировка: npv_desc (по умолчанию), npv_asc, name_asc
   */
  sort?: 'npv_desc' | 'npv_asc' | 'name_asc';

  /**
   * Размер страницы
   */
  limit?: number;

  /**
   * Смещение от начала
   */
  offset?: number;
}

export function getPortfolioEndpointDashboardsD1PortfolioGet(
  http: HttpClient,
  rootUrl: string,
  params?: GetPortfolioEndpointDashboardsD1PortfolioGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPageD1PortfolioItemDto>> {
  const rb = new RequestBuilder(rootUrl, getPortfolioEndpointDashboardsD1PortfolioGet.PATH, 'get');
  if (params) {
    rb.query('industry_id', params.industry_id, {});
    rb.query('category', params.category, {});
    rb.query('region_id', params.region_id, {});
    rb.query('sort', params.sort, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPageD1PortfolioItemDto>;
    }),
  );
}

getPortfolioEndpointDashboardsD1PortfolioGet.PATH = '/dashboards/d1/portfolio';
